/**
 * `usePublicApiClient` — hook che costruisce un `ApiClient` token‑less per le
 * pagine pubbliche (upload CV) esterne all'app shell.
 *
 * A differenza di `useApiClient`, non allega alcun Bearer token
 * (`getAccessToken` restituisce sempre `null`) e non registra alcun handler
 * `onUnauthenticated`: le pagine pubbliche non avviano mai il flusso OIDC.
 * Riusa la normalizzazione degli errori esistente (`ApiRequestError.kind`),
 * così `404` (`not_found`) e `409` (`conflict`) restano già categorizzati per
 * la UI di recap/dashboard. *Validates: 5.2, 6.1.*
 */
import { useMemo } from 'react';
import { createApiClient, type ApiClient } from './client';

export function usePublicApiClient(): ApiClient {
  return useMemo<ApiClient>(
    () =>
      createApiClient({
        // Endpoint pubblici: nessun token, quindi nessun header Authorization.
        getAccessToken: async () => null,
        // Nessun re‑login OIDC: le pagine pubbliche non gestiscono sessioni.
      }),
    [],
  );
}
